/* eslint-disable @typescript-eslint/no-namespace */
import layout, { layoutVariants } from './layout';
import color, { colorVariants } from './color';
import type { Utility } from '../../../types/utility';

export namespace LogoSection {
  /** LogoSection Component Variant Keys */
  export type ComponentKeys = 'color' | 'layout';

  /** LogoSection Components */
  export type Components = {
    /** The LogoSection color subcomponent types. */
    Color: Color.Variants;
    /** The LogoSection layout subcomponent types. */
    Layout: Layout.Variants;
  };

  /** LogoSection Component Variants */
  export type Variants = {
    [CompKey in ComponentKeys]: CompKey extends 'color'
      ? Color.Variants
      : CompKey extends 'layout'
        ? Layout.Variants
        : never;
  };

  /** LogoSection Component Variant Modes */
  export type VariantModes = {
    [CompKey in ComponentKeys]: Utility.VariantModes<
      CompKey extends 'color' ? Color.Variants : CompKey extends 'layout' ? Layout.Variants : never
    >;
  };

  /** LogoSection Color Component */
  export namespace Color {
    /** LogoSection Color Component Variant Keys */
    export type VariantKeys = 'original' | 'white' | 'dark' | 'grayscale' | 'coolGrey' | 'coolGrey70';

    /** LogoSection Color Component Variants */
    export type Variants = {
      [Key in VariantKeys]: Utility.CSSProperties;
    };
  }

  /** LogoSection Layout Component */
  export namespace Layout {
    /** LogoSection Layout Component Variant Keys */
    export type VariantKeys = 'default' | 'oneLine' | 'threeWrap' | 'fiveWrap' | 'carousel';

    /** LogoSection Layout Component Variants */
    export type Variants = {
      [Key in VariantKeys]: Utility.CSSProperties;
    };
  }

  /** LogoSection Component Scale Keys */
  export type ScaleKeys = {
    [CompKey in ComponentKeys]: CompKey extends 'color'
      ? Array<`${CompKey}.${Color.VariantKeys}`>
      : CompKey extends 'layout'
        ? Array<`${CompKey}.${Layout.VariantKeys}`>
        : never;
  };
}

const logoSection = {
  color,
  layout,
};

export const logoSectionVariants = {
  color: colorVariants,
  layout: layoutVariants,
};

export default logoSection;
